export const EXCEEDED_RATE_REASONS = [
  {
    title: 'specialised_service_request',
    description:
      "I've already requested a non-standard or specialised service with a higher price limit for this agreement.",
  },
  {
    title: 'remote_very_remote_work',
    description:
      "I'll be working in a remote (MMM6) or very remote (MMM7) area that meets the definition in the NDIS Price guide.",
  },
];

export const EXCEEDED_RATE_OTHER_REASON = {
  title: 'other',
  description: 'Other',
};
